import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { InAppBrowser } from '@ionic-native/in-app-browser';
//import { SplashScreen } from '@ionic-native/splash-screen';

import { IonicStorageModule } from '@ionic/storage';
import { ConferenceApp } from './app.component';

import { TokenInterceptor } from '../providers/token-interceptor';

import { ConferenceData } from '../providers/conference-data';
import { UserData } from '../providers/user-data';
import { Sadhona } from '../providers/sadhona';
import { OrganisationData } from '../providers/organisation-data';
import { MenteeGroupData } from '../providers/mentee-group-data';

import { AboutPage } from '../pages/about/about';
import { PopoverPage } from '../pages/about-popover/about-popover';
import { AccountPage } from '../pages/account/account';
import { LoginPage } from '../pages/login/login';
import { MapPage } from '../pages/map/map';
import { SchedulePage } from '../pages/schedule/schedule';
import { ScheduleFilterPage } from '../pages/schedule-filter/schedule-filter';
import { SessionDetailPage } from '../pages/session-detail/session-detail';
import { SignupPage } from '../pages/signup/signup';
import { SpeakerDetailPage } from '../pages/speaker-detail/speaker-detail';
import { SpeakerListPage } from '../pages/speaker-list/speaker-list';
import { TabsPage } from '../pages/tabs-page/tabs-page';
import { TutorialPage } from '../pages/tutorial/tutorial';
import { SupportPage } from '../pages/support/support';
import { HomePage } from '../pages/home/home'
import { SadhonaFormPage } from '../pages/sadhona-form/sadhona-form';
import { MenteeListPage } from '../pages/mentee-list/mentee-list';
import { UserFormPage } from '../pages/user-form/user-form';
import { UserListPage } from '../pages/user-list/user-list';
import { MenteeGroupFormPage } from '../pages/mentee-group-form/mentee-group-form';
import { AssignMentorToMenteeGroupPage } from '../pages/assign-mentor-to-mentee-group/assign-mentor-to-mentee-group';
import { ViewSadhanaPage } from '../pages/view-sadhana/view-sadhana';
import { ViewSadhanaHeaderPage } from '../pages/view-sadhana-header/view-sadhana-header';
import { GroupListPage } from '../pages/group-list/group-list';
import { ChangePasswordPage } from '../pages/change-password/change-password'
import { ViewMenteeSadhanaPage } from '../pages/view-mentee-sadhana/view-mentee-sadhana'
import { UpdateUserFormPage } from '../pages/update-user-form/update-user-form';
import { AddMenteeToMenteeGroupPage } from '../pages/add-mentee-to-mentee-group/add-mentee-to-mentee-group';
import { ViewMyMenteesPage } from '../pages/view-my-mentees/view-my-mentees';
import { ForgotPasswordPage } from '../pages/forgot-password/forgot-password';
import { ChangeForgetPasswordPage } from '../pages/change-forget-password/change-forget-password';
import { MentorApproveSadhanaPage } from '../pages/mentor-approve-sadhana/mentor-approve-sadhana';
import { CommentPage } from '../pages/comment/comment'
import { ViewReadSadhanaPage } from '../pages/view-read-sadhana/view-read-sadhana'
import { MenteeApproveSadhanaPage } from '../pages/mentee-approve-sadhana/mentee-approve-sadhana'
import { CustomDatepickerPage } from '../pages/custom-datepicker/custom-datepicker';
import { ComponentsModule } from '../component/component.module';
import { NotificationPage } from '../pages/notification/notification';
import { EmailSadhanaPage } from '../pages/email-sadhana/email-sadhana';

@NgModule({
  declarations: [
    ConferenceApp,
    AboutPage,
    AccountPage,
    LoginPage,
    MapPage,
    PopoverPage,
    SchedulePage,
    ScheduleFilterPage,
    SessionDetailPage,
    SignupPage,
    SpeakerDetailPage,
    SpeakerListPage,
    TabsPage,
    TutorialPage,
    SupportPage,
    HomePage,
    SadhonaFormPage,
    MenteeListPage,
    UserFormPage,
    UserListPage,
    MenteeGroupFormPage,
    AssignMentorToMenteeGroupPage,
    ViewSadhanaPage,
    ViewSadhanaHeaderPage,
    GroupListPage,
    ChangePasswordPage,
    ViewMenteeSadhanaPage,
    UpdateUserFormPage,
    AddMenteeToMenteeGroupPage,
    ViewMyMenteesPage,
    ForgotPasswordPage,
    ChangeForgetPasswordPage,
    MentorApproveSadhanaPage,
    CommentPage,
    ViewReadSadhanaPage,
    MenteeApproveSadhanaPage,
    CustomDatepickerPage,
    NotificationPage,
    EmailSadhanaPage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    IonicModule.forRoot(ConferenceApp, {}, {
      links: [
        { component: TabsPage, name: 'TabsPage', segment: 'tabs-page' },
        { component: SchedulePage, name: 'Schedule', segment: 'schedule' },
        { component: SessionDetailPage, name: 'SessionDetail', segment: 'sessionDetail/:sessionId' },
        { component: ScheduleFilterPage, name: 'ScheduleFilter', segment: 'scheduleFilter' },
        { component: SpeakerListPage, name: 'SpeakerList', segment: 'speakerList' },
        { component: SpeakerDetailPage, name: 'SpeakerDetail', segment: 'speakerDetail/:speakerId' },
        { component: MapPage, name: 'Map', segment: 'map' },
        { component: AboutPage, name: 'About', segment: 'about' },
        { component: TutorialPage, name: 'Tutorial', segment: 'tutorial' },
        { component: SupportPage, name: 'SupportPage', segment: 'support' },
        { component: LoginPage, name: 'LoginPage', segment: 'login' },
        { component: AccountPage, name: 'AccountPage', segment: 'account' },
        { component: SignupPage, name: 'SignupPage', segment: 'signup' },
        { component: HomePage, name: 'HomePage', segment: 'home' },
        { component: SadhonaFormPage, name: 'SadhonaFormPage', segment: 'sadhona-form' },
        { component: MenteeListPage, name: 'MenteeListPage', segment: 'mentee-list' },
        { component: UserFormPage, name: 'UserFormPage', segment: 'user-form' },
        { component: UserListPage, name: 'UserListPage', segment: 'user-list' },
        { component: MenteeGroupFormPage, name: 'MenteeGroupFormPage', segment: 'mentee-group-form' },
        { component: AssignMentorToMenteeGroupPage, name: 'AssignMentorToMenteeGroupPage', segment: 'assign-mentor-to-mentee-group' },
        { component: ViewSadhanaPage, name: 'ViewSadhanaPage', segment: 'view-sadhana' },
        { component: GroupListPage, name: 'GroupListPage', segment: 'group-list' },
        { component: ChangePasswordPage, name: 'ChangePasswordPage', segment: 'change-password' },
        { component: ViewMenteeSadhanaPage, name: 'ViewMenteeSadhanaPage', segment: 'view-mentee-sadhana' },
        { component: UpdateUserFormPage, name: 'UpdateUserFormPage', segment: 'update-user-form' },
        { component: AddMenteeToMenteeGroupPage, name: 'AddMenteeToMenteeGroupPage', segment: 'add-mentee-to-mentee-group' },
        { component: ViewMyMenteesPage, name: 'ViewMyMenteesPage', segment: 'view-my-mentees' },
        { component: ForgotPasswordPage, name: 'ForgotPasswordPage', segment: 'forgot-password' },
        { component: ChangeForgetPasswordPage, name: 'ChangeForgetPasswordPage', segment: 'change-forget-password' },
        { component: MentorApproveSadhanaPage, name: 'MentorApproveSadhanaPage', segment: 'mentor-approve-sadhana' },
        { component: CommentPage, name: 'CommentPage', segment: 'comment' },
        { component: ViewReadSadhanaPage, name: 'ViewReadSadhanaPage', segment: 'view-read-sadhana' },
        { component: MenteeApproveSadhanaPage, name: 'MenteeApproveSadhanaPage', segment: 'mentee-approve-sadhana' },
        { component: CustomDatepickerPage, name: 'CustomDatepickerPage', segment: 'mentee-approve-sadhana' },
        { component: EmailSadhanaPage, name: 'EmailSadhanaPage', segment: 'email-sadhana-page' },
      ]
    }),
    IonicStorageModule.forRoot(),
    ComponentsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    ConferenceApp,
    AboutPage,
    AccountPage,
    LoginPage,
    MapPage,
    PopoverPage,
    SchedulePage,
    ScheduleFilterPage,
    SessionDetailPage,
    SignupPage,
    SpeakerDetailPage,
    SpeakerListPage,
    TabsPage,
    TutorialPage,
    SupportPage,
    HomePage,
    SadhonaFormPage,
    MenteeListPage,
    UserFormPage,
    UserListPage,
    MenteeGroupFormPage,
    AssignMentorToMenteeGroupPage,
    ViewSadhanaPage,
    ViewSadhanaHeaderPage,
    GroupListPage,
    ChangePasswordPage,
    ViewMenteeSadhanaPage,
    UpdateUserFormPage,
    AddMenteeToMenteeGroupPage,
    ViewMyMenteesPage,
    ForgotPasswordPage,
    ChangeForgetPasswordPage,
    MentorApproveSadhanaPage,
    CommentPage,
    ViewReadSadhanaPage,
    MenteeApproveSadhanaPage,
    CustomDatepickerPage,
    NotificationPage,
    EmailSadhanaPage
  ],
  providers: [
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    {
      provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true
    },
    ConferenceData,
    UserData,
    Sadhona,
    OrganisationData,
    MenteeGroupData,
    InAppBrowser
    //SplashScreen
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts